import { DotLottie } from '@lottiefiles/dotlottie-web'

window.Lottie = DotLottie
